module.exports = __webpack_public_path__ + "img/label_vip@2x.de8740a7.png";